import ExcelJS from 'exceljs';

export function setExcelDateTimeFormat(cell: ExcelJS.Cell, rawValue: string, useDefaultDash = true) {
    if (!rawValue) {
      cell.value = useDefaultDash ? '-' : "";
      return;
    }

    // Caso 1: Solo fecha
    if (/^\d{4}[/-]\d{2}[/-]\d{2}$/.test(rawValue)) {
      cell.value = rawValue;             // dejar como string
      cell.numFmt = 'yyyy/mm/dd';        // solo apariencia
      return;
    }

    // Caso 2: Solo hora
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(rawValue)) {
      cell.value = rawValue;             // string
      cell.numFmt = 'hh:mm:ss';          // apariencia
      return;
    }

    // Caso 3: Fecha y hora combinadas
    if (/^\d{4}[/-]\d{2}[/-]\d{2}\s+\d{2}:\d{2}(:\d{2})?$/.test(rawValue)) {
      cell.value = rawValue;             // string
      cell.numFmt = 'dd/mm/yyyy hh:mm:ss';
      return;
    }

    // Si no matchea, dejar el valor como texto
    cell.value = rawValue;
  }

export function setExcelDateTimeFormatFromValue(
  cell: ExcelJS.Cell,
  rawValue: string,
  type: 'date' | 'time' | 'datetime',
  useDefaultDash = true
) {
  // si viene vacío
  if (!rawValue || rawValue.trim() === '') {
    cell.value = useDefaultDash ? '-' : '';
    return;
  }

  try {
    // Caso: fecha y hora con AM/PM (dd/mm/yyyy HH:mm:ss a. m./p. m.)
    if (type === 'datetime') {
      const datetimeMatch = rawValue.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(a\.\s*m\.|p\.\s*m\.)/i);
      
      if (datetimeMatch) {
        const [_, day, month, year, hours, minutes, seconds, period] = datetimeMatch;
        
        // Convertir AM/PM a formato 24h
        let hour24 = parseInt(hours);
        const isPM = period.toLowerCase().includes('p');
        
        if (isPM && hour24 < 12) hour24 += 12;
        else if (!isPM && hour24 === 12) hour24 = 0;
        
        // Crear fecha UTC (sin ajustes de zona horaria)
        const utcDate = new Date(Date.UTC(
          parseInt(year), parseInt(month) - 1, parseInt(day),
          hour24, parseInt(minutes), parseInt(seconds)
        ));
        
        cell.value = utcDate;
        cell.numFmt = 'dd/mm/yyyy hh:mm:ss';
        return;
      }
    }

    // Caso: fecha y hora formato 24h (sin AM/PM)
    if (type === 'datetime') {
      const datetimeMatch = rawValue.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})$/);
      
      if (datetimeMatch) {
        const [_, day, month, year, hours, minutes, seconds] = datetimeMatch;
        
        // Crear fecha UTC
        const utcDate = new Date(Date.UTC(
          parseInt(year), parseInt(month) - 1, parseInt(day),
          parseInt(hours), parseInt(minutes), parseInt(seconds)
        ));
        
        cell.value = utcDate;
        cell.numFmt = 'dd/mm/yyyy hh:mm:ss';
        return;
      }
    }

    // Caso: solo fecha (dd/mm/yyyy)
    if (type === 'date' && /^\d{2}\/\d{2}\/\d{4}$/.test(rawValue)) {
      const [day, month, year] = rawValue.split('/').map(Number);
      
      // Crear fecha UTC (mediodía para evitar problemas de zona horaria)
      const utcDate = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
      
      cell.value = utcDate;
      cell.numFmt = 'dd/mm/yyyy';
      return;
    }

    // Caso: solo hora
    if (type === 'time') {
      if (/\d{1,2}:\d{2}:\d{2}\s*(a\.\s*m\.|p\.\s*m\.)/i.test(rawValue)) {
        const timeMatch = rawValue.match(/^(\d{1,2}):(\d{2}):(\d{2})\s*(a\.\s*m\.|p\.\s*m\.)/i);
        if (timeMatch) {
          const [_, hours, minutes, seconds, period] = timeMatch;
          
          let hour24 = parseInt(hours);
          const isPM = period.toLowerCase().includes('p');
          
          if (isPM && hour24 < 12) hour24 += 12;
          else if (!isPM && hour24 === 12) hour24 = 0;
          
          // Usar fecha base UTC (1900-01-01) + hora
          const utcDate = new Date(Date.UTC(1900, 0, 1, hour24, parseInt(minutes), parseInt(seconds)));
          
          cell.value = utcDate;
          cell.numFmt = 'hh:mm:ss';
          return;
        }
      } else if (/^\d{1,2}:\d{2}:\d{2}$/.test(rawValue)) {
        const [hours, minutes, seconds] = rawValue.split(':').map(Number);
        
        // Usar fecha base UTC + hora
        const utcDate = new Date(Date.UTC(1900, 0, 1, hours, minutes, seconds));
        
        cell.value = utcDate;
        cell.numFmt = 'hh:mm:ss';
        return;
      }
    }

    // Último recurso: dejar como texto
    cell.value = rawValue;
  } catch {
    cell.value = useDefaultDash ? '-' : rawValue;
  }
}